"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
//import app components
const colors_1 = __importDefault(require("./colors"));
const typography_1 = __importDefault(require("./typography"));
const overrides_1 = __importDefault(require("./overrides"));
const mui = (0, styles_1.createTheme)({
    palette: {
        primary: {
            main: colors_1.default.primary[900],
        },
        secondary: {
            main: colors_1.default.secondary[900],
        },
        text: {
            primary: colors_1.default.text[100],
            secondary: colors_1.default.text[600],
        },
    },
    typography: {
        ...typography_1.default,
        overline: typography_1.default.nav,
    },
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    components: {
        ...overrides_1.default,
    },
});
exports.default = mui;
